import { useNav } from "@pomle/react-router-paths";
import { paths } from "render/routes/paths";
import { FullScreenPageLayout } from "render/ui/layout/FullScreenPageLayout";
import { LogoHeader } from "render/ui/layout/LogoHeader";
import { Typography } from "render/ui/presentation/Typography";
import { ActionButton } from "render/ui/trigger/ActionButton";
import { VideoBackground } from "render/views/_shared/VideoBackground";
import { Trans } from "../../../../../../trans";
import styles from "./styles.module.sass";

export function SuccessState({
  slotId,
  roomId,
}: {
  slotId: string;
  roomId: string;
}) {
  const nav = {
    appointment: useNav(paths.checkInAppointment),
    onBoarding: useNav(paths.onboarding),
  };
  return (
    <FullScreenPageLayout disableBackground>
      <div className={styles.SuccessState}>
        <div className={styles.sticky}>
          <LogoHeader />
        </div>
        <div className={styles.body}>
          <div className={styles.content}>
            <Typography style={{ marginBottom: "8px" }} variant="title-large">
              <Trans.ThanksCheckedIn />
            </Typography>
            <Typography
              style={{ marginBottom: "32px" }}
              variant="title-medium"
              color="subtle"
            >
              <Trans.CheckInSuccess.WelcomeWeAreReady />
            </Typography>
            <ActionButton
              onClick={() => {
                nav.appointment.go({ slotId, roomId });
              }}
            >
              <Trans.CheckInSuccess.OpenBooking />
            </ActionButton>
          </div>
        </div>
      </div>
      <VideoBackground />
    </FullScreenPageLayout>
  );
}
